export default "__VITE_ASSET__Tvm_a9b1__"